import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SupplierSearchPageRoutingModule } from './supplier-search-routing.module';
import { SupplierSearchComponent } from './supplier-search.component';
import { JwPaginationModule } from 'jw-angular-pagination';
import { PaginationComponent } from 'src/app/shared/pagination/pagination.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SupplierSearchPageRoutingModule,
    JwPaginationModule,
  ],
  exports: [
    PaginationComponent
  ],
  declarations: [SupplierSearchComponent, PaginationComponent]
})
export class SupplierSearchModule { }
